import React from "react";
import DashboardLayout from "../../layout/DashboardLayout.js";
import TeamsListsDetails from "./TeamsListsDetails";
import { Box } from "@mui/material";

function TeamsView() {
  // const [drawerOpen, setDrawerOpen] = useState(true);

  return (
    <DashboardLayout pageName="Teams">
      {/* <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' },  gap: 2}}> */}
        <TeamsListsDetails />
      {/* </Box> */}
    </DashboardLayout>
  );
}

export default TeamsView;